import { Injectable } from "@angular/core";
import { ParseService } from "../parse/parse.service";
import { QueryInterface } from "../parse/query-interface";
import { Subject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})

export class ClientService {

    profileValues = new Subject<any>();

    constructor(
        private parseService: ParseService,
        private queryInterface: QueryInterface
    ) { }

    updateClient(objectId, clientValues): Promise<any> {
        return new Promise((resolve, reject) => {
            this.queryInterface.executeQuery(this.parseService, "Client", [
                { condition: "equalTo", field: "objectId", value: objectId }]).then(result => {
                    var results = result[0];
                    results.set("companyInfo", clientValues.companyInfo);
                    results.set("contactInfo", clientValues.contactInfo);
                    results.save().then(res => {
                        resolve(res);
                    });
                });
        });
    }

    getProfileData(): Observable<any> {
        this.profileValues.next();
        return this.profileValues.asObservable();
    }

}
